// Recently Viewed Reducer

import {
  GET_RECENTLY_VIEWED_LIST,
  GET_RECENTLY_VIEWED_LIST_SUCCESS,
  GET_RECENTLY_VIEWED_LIST_FAIL,
} from "./actionType";

const initialState = {
  recentlyViewedList: [],
  loading: false,
  error: "",
};

const RecentlyViewed = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECENTLY_VIEWED_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_RECENTLY_VIEWED_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        recentlyViewedList: action.payload,
      };
      break;
    case GET_RECENTLY_VIEWED_LIST_FAIL:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RecentlyViewed;
